import React from 'react';
import PropTypes from 'prop-types';
import './style';

const Radio = (props) => {
  const {
    label,
    subText,
    onChange,
    checked,
    disabled,
    className,
    id,
    ...attr
  } = props;

  const onClick = (e) => {
    if (!disabled) onChange(id, e);
  };

  return (
    <div
      className={`radio-wrapper flex gap-2${checked ? ' checked' : ''}${disabled ? ' disabled' : ''} ${className}`}
      onClick={onClick}
      {...attr}
    >
      <div className="radio-select" />
      <input type="radio" />
      {(label || subText) && (
        <div className="label-wrapper flex flex-col justify-center gap-1">
          {label && (<span className="label label-14">{label}</span>)}
          {subText && (<span className="sub-text text-14">{subText}</span>)}
        </div>)}
    </div>
  );

};

Radio.propTypes = {
  label: PropTypes.node,
  subText: PropTypes.node,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
};

Radio.defaultProps = {
  label: '',
  subText: '',
  onChange: () => null,
  checked: false,
  disabled: false,
  className: '',
  id: '',
};

export default Radio;
